app.config(
    ['$rootScopeProvider',
        function ($rootScopeProvider) {
            $rootScopeProvider.digestTtl(120);
        }]);